"use client";

import { c as _c } from "react/compiler-runtime";
import { AdvancedMarker, AdvancedMarkerAnchorPoint } from "@vis.gl/react-google-maps";
import React, { forwardRef, memo } from "react";
import { getIconBySlug } from "@/utils/icon-mapping";
const MapMarker = forwardRef(function MapMarker(props, ref) {
  const $ = _c(23);
  let t0;
  if ($[0] !== props.club.theme) {
    t0 = props.club.theme?.icon?.slug ? getIconBySlug(props.club.theme.icon.slug) : null;
    $[0] = props.club.theme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const ThemeIcon = t0;
  let t1;
  if ($[2] !== props.club.format || $[3] !== props.club.theme) {
    t1 = () => {
      if (props.club.theme) {
        return "bg-yellow";
      }
      if (props.club.format === "fortnightly") {
        return "bg-event";
      }
      if (props.club.format === "weekly") {
        return "bg-primary";
      }
      return "bg-concept-green";
    };
    $[2] = props.club.format;
    $[3] = props.club.theme;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getMarkerColorClass = t1;
  let t2;
  if ($[5] !== props) {
    t2 = event => props.onMouseEnter(event, props.club);
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props) {
    t3 = event_0 => props.onClick(event_0, props.club);
    $[7] = props;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = `map-marker ${getMarkerColorClass()} flex items-center justify-center`;
  let t5;
  if ($[9] !== ThemeIcon) {
    t5 = ThemeIcon && <ThemeIcon className="w-5 h-5 text-white" />;
    $[9] = ThemeIcon;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props.club.name) {
    t7 = <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block whitespace-nowrap bg-white text-xs font-semibold text-gray-800 px-2 py-1 rounded shadow-md pointer-events-none">{props.club.name}</div>;
    $[14] = props.club.name;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== props.position || $[17] !== ref || $[18] !== t2 || $[19] !== t3 || $[20] !== t6 || $[21] !== t7) {
    t8 = <><AdvancedMarker ref={ref} position={props.position} clickable={true} className="group relative hover:z-20" onMouseEnter={t2} collisionBehavior={google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY} onClick={t3} anchorPoint={AdvancedMarkerAnchorPoint.CENTER}>{t6}{t7}</AdvancedMarker></>;
    $[16] = props.position;
    $[17] = ref;
    $[18] = t2;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
});
export default memo(MapMarker);